import { useEffect } from "react";

/**
 * Ferme un panel quand :
 * - clic/tap en dehors
 * - Escape
 *
 * panelRef: ref qui englobe trigger + dropdown (wrapper)
 */
export function useDismiss({ open, panelRef, onClose }) {
  useEffect(() => {
    if (!open) return;

    const handleInteractOutsideCapture = (e) => {
      const el = panelRef?.current;
      if (!el) return;

      // clic à l'intérieur => ne rien faire
      if (el.contains(e.target)) return;

      onClose?.();
    };

    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };

    // capture = plus fiable (évite certains cas où ça “flicker”)
    document.addEventListener("mousedown", handleInteractOutsideCapture, true);
    document.addEventListener("touchstart", handleInteractOutsideCapture, true);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("mousedown", handleInteractOutsideCapture, true);
      document.removeEventListener("touchstart", handleInteractOutsideCapture, true);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, panelRef, onClose]);
}
